import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'
import { AppConfig } from 'src/app/app.config'
import { MeasurementUnits } from 'src/app/common/measurement-units.model'

interface ServerDeploymentSettings {
  id: number
  measurement_units: MeasurementUnits
}

@Injectable({
  providedIn: 'root',
})
export class CenterMeasurementUnitsService {
  constructor(private http: HttpClient, private appConfig: AppConfig) {
    const url = this.appConfig.config.server_api.centers.deployment_settings
    this.http.get<ServerDeploymentSettings>(url).subscribe(({ measurement_units }) => {
      this.centerMeasurementUnitsSubject.next(MeasurementUnits[measurement_units])
    })
  }

  centerMeasurementUnitsSubject = new BehaviorSubject<MeasurementUnits | null>(null)
  centerMeasurementUnits$ = this.centerMeasurementUnitsSubject.asObservable()

  setCenterMeasurementUnits = (measurementUnits: MeasurementUnits): Observable<object> => {
    this.centerMeasurementUnitsSubject.next(measurementUnits)
    const url = this.appConfig.config.server_api.centers.deployment_settings
    const measurement_units = Object.keys(MeasurementUnits).filter(
      (name) => MeasurementUnits[name] === measurementUnits,
    )?.[0]
    return this.http.post(url, { measurement_units })
  }
}
